import { EmpleadoDto, EmpleadoAsistencia, SearchEmpleadoAsistenciaExport, MotivoInasistencia, SaveEmpleadoComunidad, SaveEmpleadoDto } from './../../shared/model/empleado';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { DataManager, WebApiAdaptor, Query } from '@syncfusion/ej2-data';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { GridComponent, PageSettingsModel, SelectionSettingsModel, ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { isNumber } from 'highcharts';
import { debounceTime, distinctUntilChanged, filter, finalize, switchMap, tap } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

import { ComunidadService, EmpleadoService, GremioService, MenuFuncionService, TenantService } from '../../../../src/app/shared/services';
import { GridPageSettings, MenuFuncionCodes, Comunidad, SearchComunidadRequest, SearchEmpleadoRequestDto, SaveEmpleadoAsistencia, ExportMediaTypeConstants } from '../../../../src/app/shared/model';
import { Gremio, SearchGremioRequest, DialogModificarFechaRequest, DialogMotivoInasistenciaRequest, DialogMotivoInasistenciaResponse } from '../../../../src/app/shared/model';

import { DialogModificarFechaComponent } from './component/dialogModificarFecha.component';
import { DialogMotivoInasistenciaComponent } from './component/dialogMotivoInasistencia.component';
import { MAT_DATE_LOCALE } from '@angular/material/core';

@Component({
  selector: 'app-asistenciasLista',
  templateUrl: './asistenciasLista.component.html',
  styleUrls: ['./asistenciaLista.component.scss']
})

export class AsistenciasListaComponent implements OnInit {
  @ViewChild('grid')
  public grid: GridComponent;
  mesesList = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
  public data: DataManager;
  empleadoControl = new FormControl('');

  isValidating: boolean = false;
  isSearching: boolean = false;
  isExporting: boolean = false;
  isFormValid: boolean = false;
  isGremiosSearching: boolean = false;
  isEmpleadoSerching: boolean = false;
  isMotivoInasisSerching: boolean = false;
  isComunidadSearching: boolean = false;
  isSubContratistaSearching: boolean = false;
  isEmpleadoSaving: boolean = false;
  tableError: boolean = false;
  canEdit: boolean = false;
  canView: boolean = false;
  canConfig: boolean = false;

  asistenciaForm: FormGroup;
  searchForm: FormGroup;
  isSaving: boolean = false;

  item: SaveEmpleadoAsistencia;

  gremioList: Gremio[];
  comunidadList: Comunidad[];
  verSoloActivos: boolean = true;
  asistenciaList: any[] = [];
  selectedEmpleados: any[];
  public query: Query;

  public selectionOptions: SelectionSettingsModel;
  public pageSizes: number[];
  public toolbarOptions: ToolbarItems[] = ['ExcelExport'];
  public pageSettings: PageSettingsModel;
  tipoAsistenciaList: any[];
  motivoInasistenciaSelected: string;

  fechaInicial: any[];
  intervaloDias: number[];
  empleadoList: EmpleadoDto[];
  filteredEmpleadoList: EmpleadoDto[];
  motivoInasistenciaList: MotivoInasistencia[];
  result: any[];
  mesesDias: any[];
  asistenciasMarcadas: any[] = [];
  desdeDate: Date = new Date();
  hastaDate: Date = new Date();
  empleadoId: number = 0;
  valueInput: number = 8;
  filteredSubContratistaList: EmpleadoDto[];
  filteredComunidadesList: any[];

  constructor(
    private formBuilder: FormBuilder,
    private menuService: MenuFuncionService,
    private sharedFunctions: SharedFunctions,
    private comunidadService: ComunidadService,
    private empleadoService: EmpleadoService,
    private gremioService: GremioService,
    private tenantService: TenantService,
    private datePipe: DatePipe,
    private router: Router,
    private dialog: MatDialog,
    @Inject(MAT_DATE_LOCALE) private _locale: string | null,
  ) { }

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenu(MenuFuncionCodes.EMPLEADO_ASISTENCIA_LIST).subscribe(data => {
      this.isValidating = false;
      if (data != null && data.Success && data?.Result)
        this.loadView();
      else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.router.navigate(['/']);
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  loadView() {
    this.canView = true;

    this.buildForm();
    this.getGremios();
    this.getComunidades();
    this.getTipoAsistencia();
    this.getEmpleados();
    this.getSubContratistas();
    /* this.getMotivoInasistenciaMotivo(); */

    this.pageSizes = GridPageSettings.PageSizeList;
    this.pageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[1], pageSizes: this.pageSizes };


    this.setQueryParams();
    this.data = new DataManager({
      url: this.empleadoService.getSearchUrl(),
      adaptor: new WebApiAdaptor(),
      headers: [this.empleadoService.getAuthorizationHeader(), this.empleadoService.getTenantHeader()]
    });
  }

  getSubContratistas() {
    this.searchForm.get("SubContratista")?.valueChanges
            .pipe(
            filter(res => {
                return res && res !== null && res.length >= 3
            }),
            distinctUntilChanged(),
            debounceTime(1000),
            tap(() => {
                this.filteredSubContratistaList = [];
                this.isSubContratistaSearching = true;
            }),
            switchMap(value => this.empleadoService.search(new SearchEmpleadoRequestDto(50, null, true, "Nombre", null, null, null, (!isNumber(parseInt(value)) ? value : null), null, null, null, null, (isNumber(parseInt(value)) ? value : null), null, null, true, false))
                .pipe(
                finalize(() => {
                    this.isSubContratistaSearching = false;
                }),
                )
            )
            )
            .subscribe((data: any) => {
                if (data != null && data.result != null)
                    this.filteredSubContratistaList = data.result;
                else
                    this.filteredSubContratistaList = [];
            });
  }

  agregarEmpleadoObra(Empleado: EmpleadoDto) {
    if(Empleado.Comunidades.some(x => x.ComunidadId == this.asistenciaForm.value.Comunidad.Id)){
      this.sharedFunctions.showMessage("El empleado ya se encuentra en la Obra!", "Error");
      return;
    }

    this.empleadoService.get(Empleado.Id).subscribe(data => {
      this.isSearching = false;
      if (data != null && data.Success) {
        let empleado = data.Result;
        var s = [new SaveEmpleadoComunidad(0, this.asistenciaForm.value.Comunidad.Id, Empleado.Id, this.asistenciaForm.value.FechaDesde, null)];
        var r = new SaveEmpleadoDto(0, null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null, null, null,null,null
          ,null,null,null,null,null,null,null,null,null,null,null,null, s,null, true);
          if(empleado != null){

            Object.assign(r,empleado);

            this.isEmpleadoSaving = true;
            this.empleadoService.save(r).subscribe(data => {
              this.isEmpleadoSaving = false;
              if (data != null && data.Success && data.Result != null && data.Result.Id > 0) {
                this.onSearch();
                this.sharedFunctions.showMessage("Se agrego el empleado a la obra!", "Operación Exitosa!");
              }
              else{
                this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
              }
            },
              (err: HttpErrorResponse) => {
                this.isEmpleadoSaving = false;
                this.sharedFunctions.handleError(err, true);
              })
          }
      }
    },
    (err: HttpErrorResponse) => {
      this.isSearching = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  agregarNuevoEmpleado() {
    this.router.navigate(['empleado-edit/' + 0]);
  }

  getEmpleados() {
    this.empleadoControl.valueChanges
    .pipe(
    filter(res => {
        return res && res !== null && res.length >= 3
    }),
    distinctUntilChanged(),
    debounceTime(1000),
    tap(() => {
        this.filteredEmpleadoList = [];
        this.isEmpleadoSerching = true;
    }),
    switchMap(value => this.empleadoService.search(new SearchEmpleadoRequestDto(50, null, true, "Nombre", null, null, null, (!isNumber(parseInt(value)) ? value : null), null, null, null, null, (isNumber(parseInt(value)) ? value : null), null, null, false, true))
      .pipe(
      finalize(() => {
        this.isEmpleadoSerching = false;
      }),
      )
    )
    )
    .subscribe((data: any) => {
        if (data != null && data.result != null)
            this.filteredEmpleadoList = data.result;
        else
            this.filteredEmpleadoList = [];
    });
  }

  getComunidades() {
    var loggedUser = this.sharedFunctions.getLoggedUser();
    var r = new SearchComunidadRequest(null, null, true, "Nombre", null, null, loggedUser?.PersonaId ?? 0, null, null, true);
    this.isComunidadSearching = true;

    this.comunidadService.search(r).subscribe(data => {
      this.isComunidadSearching = false;
      if (data != null) {
        this.comunidadList = data?.result;
      }
    },
    (err: HttpErrorResponse) => {
      this.isComunidadSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getErrorComunidad(): string{
    return this.asistenciaForm.get("Comunidad")?.hasError('invalid') ? "No se encontró el item solicitado." : "";
  }

  onSearch() {
    this.tableError = false;
    if (!this.asistenciaForm.valid) {
      this.sharedFunctions.showMessage("Por favor revise los parámetros de búsqueda nuevamente", "Error");
      return;
    }

    this.intervaloDias = [];
    this.fechaInicial = [];
    this.setQueryParams();

    var search = new SearchEmpleadoRequestDto(null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, this.verSoloActivos);
    search =
    {
      ...this.searchForm.value,
      ...this.asistenciaForm.value,
      ComunidadId: this.asistenciaForm.get("Comunidad")?.value?.Id
    };

    this.isSearching = true;
    this.empleadoService.getEmpleadoAsistencia(search).subscribe((result) => {
      this.isSearching = false;
      this.tableError = !result.Success;

      if (result != null && result.Success) {
        this.asistenciaList = result.Result;
        this.asistenciasMarcadas = this.asistenciaList?.filter(x => x.Id != 0);
        this.setIntervalo();
      }
      else
        this.sharedFunctions.showMessage("Ocurrió un error realizando la búsqueda", "Error");
    },
    (err:HttpErrorResponse) => {
      this.tableError = true;
      this.isSearching = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  redirectToFichaEmpleado(args: any) {
    this.router.navigateByUrl('empleado-edit/' + args);
  }

  setIntervalo() {
    this.result = [];
    this.mesesDias = [];
    this.fechaInicial = [];

    var loop = new Date(this.asistenciaForm.get('FechaDesde')?.value);

    for (let i: Date = loop; i <= (this.asistenciaForm.get('FechaHasta')?.value ?? -1); i.setDate(i.getDate() + 1)) {
      this.fechaInicial.push(
        {
          "Anio": i.getUTCFullYear(),
          "Nombre": i.toLocaleString('default', { month: 'long' }).toUpperCase(),
          "Dias": i.getDate() < 10 ? "0" + i.getDate() : i.getDate()
        });
    }
    const elementMesExist = (map, value) => {
      return map.has(value) ? map.get(value) : false;
    };

    const mesesDiasMap = new Map();
    for (const e of this.fechaInicial) {
      let i = elementMesExist(mesesDiasMap, e.Nombre);
      if (i === false) {
        // Si no existe, creo agrego un nuevo objeto.
        this.mesesDias.push({
          "Anio": e.Anio,
          "Nombre": e.Nombre,
          "Dias": [e.Dias],
          "Tipo": this.tipoAsistenciaList,
        });
        mesesDiasMap.set(e.Nombre, this.mesesDias.length - 1);
      } else {
        // Si el ya existe agrego el nuevo elemento a el array valor.
        this.mesesDias[i].Dias.push(e.Dias);
      }
    }

    const elementNombreExist = (map, value) => {
      return map.has(value) ? map.get(value) : false;
    };

    const resultMap = new Map();
    for (const e of this.asistenciaList) {
      let i = elementNombreExist(resultMap, e.EmpleadoId);
      if (i === false) {
        // Si no existe, creo agrego un nuevo objeto.
        this.result.push({
          "EmpleadoId": e.EmpleadoId,
          "ComunidadId": e.ComunidadId,
          "GremioId": e.GremioId,
          "GremioNombre": e.GremioNombre,
          "Legajo": e.Legajo,
          "EmpleadoApellido": e.EmpleadoApellido,
          "EmpleadoNombre": e.EmpleadoNombre,
          "Intervalo": this.mesesDias,
        });
        resultMap.set(e.EmpleadoId, this.result.length - 1);
      } else {
        if (e.GremioId > 0) {
          this.result[i].GremioId = e.GremioId;
        }
        if (e.GremioNombre != "") {
          this.result[i].GremioNombre = e.GremioNombre;
        }
      }
    }
  }

  grisarColumna(empleado, tipoAsis, fecha) {
    let empleadoAsistencia = this.asistenciaList.find(j => j.EmpleadoId == empleado.EmpleadoId && j.FechaAsistencia == fecha);
    if (empleadoAsistencia == undefined) {
      return false;
    }

    empleadoAsistencia = this.asistenciaList.find(j => j.EmpleadoId == empleado.EmpleadoId && j.FechaAsistencia == fecha);
    if (empleadoAsistencia.EmpleadoId == empleado.EmpleadoId &&
        empleadoAsistencia.Asistencia > 0 &&
        empleadoAsistencia.FechaAsistencia == fecha &&
        empleadoAsistencia.MotivoInasistencia != "" &&
        empleadoAsistencia.MotivoInasistencia != null) {
      var elemento = document.getElementById("colorBoxes" + empleado.EmpleadoId + tipoAsis + empleado.FechaAsistencia);
      if (elemento != null)
        elemento.className += " grisarBloque";
      return true;
    }
  }

  private getMes(meses: any): string {
    let mesBuscar: string = "";

    if (meses != null) {
        var mm = this.mesesList.find(x => x.toUpperCase() == meses.Nombre);
        if (mm != null) {
            mesBuscar = (this.mesesList.indexOf(mm) + 1).toString();
            if (parseInt(mesBuscar) == 0)
                mesBuscar = this.getMonthFromString(meses.Nombre).toString();
            if (parseInt(mesBuscar) < 10) {
                mesBuscar = "0" + mesBuscar;
            }
        }
    }

    return mesBuscar;
}

  verAsis(tipoId, empleado, dias, meses) {
    const mesBuscar = this.getMes(meses);

    let fechaAsistencia: Date = new Date(meses.Anio + "-" + mesBuscar + "-" + dias + "T00:00:00");
    let fechaFormated = this.formatDate(fechaAsistencia);
    let empleadoAsistencia = this.asistenciaList.find(j => j.EmpleadoId == empleado.EmpleadoId && j.Asistencia == tipoId && j.FechaAsistencia == meses.Anio + "-" + mesBuscar + "-" + dias + "T00:00:00");
    if (empleadoAsistencia == undefined)
      return 0;
    //2023-01-06T00:00:00
    if (empleadoAsistencia.EmpleadoId == empleado.EmpleadoId && empleadoAsistencia.Asistencia > 0 && empleadoAsistencia.Asistencia == tipoId && empleadoAsistencia.FechaAsistencia == fechaFormated && empleadoAsistencia.HorasAsistencia > 0) {
      return empleadoAsistencia.HorasAsistencia;
    } else {
      return 0;
    }
  }

  getMonthFromString(mon) {
    var d = Date.parse(mon + "1, 2012");
    if(!isNaN(d)){
       return new Date(d).getMonth() + 1;
    }
    return -1;
  }

  formatDateGris(mes, dia): string {
    const mesBuscar = this.getMes(mes);
    return mes.Anio + "-" + mesBuscar + "-" + dia + "T00:00:00";
  }

  formatDate(fecha: Date): string | null {
    if (fecha != null) {
      let asistenciaDia = this.datePipe.transform(fecha, "dd");
      let asistenciaMes = this.datePipe.transform(fecha, "MM");
      let asistenciaAnio = this.datePipe.transform(fecha, "yyyy");
      return asistenciaAnio + "-" + asistenciaMes + "-" + asistenciaDia + "T00:00:00";
    }

    return null;
  }

  comprobarAsist(tipoId?, empleado?, dias?, meses?, dialogRes?: DialogMotivoInasistenciaResponse | null) {
    const mesBuscar = this.getMes(meses);

      let fechaAsistencia: Date = dialogRes ? new Date(dialogRes?.FechaAsistencia ?? "") : new Date(meses.Anio + "-" + mesBuscar + "-" + dias + "T00:00:00");
      let fechaFormated = this.formatDate(fechaAsistencia);
      let empleadoId = dialogRes && dialogRes?.EmpleadoId != 0 ?  dialogRes?.EmpleadoId : empleado?.EmpleadoId;
      tipoId = dialogRes ? dialogRes?.TipoAsistencia : tipoId;

      if (tipoId == 2 && new Date(fechaFormated ?? "") > new Date()){
        this.sharedFunctions.showMessage("No se puede asignar presentismo mas alla de la fecha actual", "Error");
        return;
      }

      if (dialogRes?.EsDia) {
        this.marcarAsistencia(dialogRes, fechaFormated, empleadoId,tipoId);
        return;
      }

      this.empleadoService.get(empleadoId).subscribe(data => {
        this.isSearching = false;
        if (data != null && data.Success) {

          let fechaInicio = data.Result.Comunidades.find(x => x.ComunidadId == this.asistenciaForm.value.Comunidad.Id && x.EmpleadoId == empleadoId)?.FechaInicio;
          let fechaFin = data.Result.Comunidades.find(x => x.ComunidadId == this.asistenciaForm.value.Comunidad.Id && x.EmpleadoId == empleadoId)?.FechaFin;
          if ((fechaFormated ?? "") < fechaInicio){
            this.sharedFunctions.showMessage("El empleado solo puede tener presentismo desde la fecha: " + this.datePipe.transform(fechaInicio, "dd/MM/yyyy"), "Error");
            return;
          }
          else if(fechaFin < (fechaFormated ?? "")) {
            this.sharedFunctions.showMessage("El empleado solo puede tener presentismo hasta la fecha: " + this.datePipe.transform(fechaFin, "dd/MM/yyyy"), "Error");
            return;
          }
          this.marcarAsistencia(dialogRes, fechaFormated, empleadoId,tipoId);
        }
      },
      (err: HttpErrorResponse) => {
        this.isSearching = false;
        this.sharedFunctions.handleError(err, true);
      })

  }

  marcarAsistencia(dialogRes?, fechaFormated?, empleadoId?, tipoId?) {

    if(dialogRes?.EsDia) {
      this.asistenciaList.forEach(x =>{
        if(x.FechaAsistencia == fechaFormated && !(fechaFormated < x.FechaInicio && (x.FechaFin < fechaFormated || x.FechFin == null))){
          if(x.Asistencia == 1){
            x.Asistencia = dialogRes ? dialogRes?.TipoAsistencia : tipoId;
            x.HorasAsistencia = dialogRes ? dialogRes?.HorasAsistencia : 8;
            x.MotivoInasistenciaId = dialogRes ? dialogRes?.MotivoInasistenciaId : null;
          }else if(x.Asistencia == 2){
            x.Asistencia = 0;
            x.HorasAsistencia = 0;
            x.MotivoInasistenciaId = null;
          }
        }
        this.asistenciasMarcadas.push(x);
        this.asistenciasMarcadas = this.asistenciasMarcadas.filter(x => x.Asistencia > 0);
        this.asistenciasMarcadas = [...new Set(this.asistenciasMarcadas)];
      })
    }
    else {
      let empleadoAsistencia = this.asistenciaList.filter(j => j.EmpleadoId == empleadoId && j.FechaAsistencia == fechaFormated);
      if(!empleadoAsistencia) {
        empleadoAsistencia = this.asistenciaList.filter(j => j.EmpleadoId == empleadoId && j.FechaAsistencia == fechaFormated && j.Asistencia == 0);
      }

      empleadoAsistencia.forEach(x =>{
        if(x.FechaAsistencia == fechaFormated && !(fechaFormated < x.FechaInicio && (x.FechaFin < fechaFormated || x.FechFin == null))){
          if(x.Asistencia == tipoId || x.Asistencia == 0){
            x.Asistencia = dialogRes ? dialogRes?.TipoAsistencia : tipoId;
            x.HorasAsistencia = dialogRes ? dialogRes?.HorasAsistencia : 8;
            x.MotivoInasistenciaId = dialogRes ? dialogRes?.MotivoInasistenciaId : null;
          }else{
            x.Asistencia = tipoId == 1 ? 2 : tipoId == 2 ? 1 : 0;
            x.HorasAsistencia = 0;
            x.MotivoInasistenciaId = null;
          }
        }
        this.asistenciasMarcadas.push(x);
      })
    }
  }

  validateCuit(cuit) {
    //27-28033514-8
    for (let i = 0; i < cuit.length; i++) {
      if (i != 2 && i != 11 && !isNumber(parseInt(cuit[i]))) {
        this.searchForm.controls['Cuit'].setErrors({ 'incorrect': true });
      }
      else if (i == 2 && cuit[i] != "-") {
        this.searchForm.controls['Cuit'].setErrors({ 'incorrect': true });
      }
      else if (i == 11 && cuit[i] != "-") {
        this.searchForm.controls['Cuit'].setErrors({ 'incorrect': true });
      }
    }
    if (cuit.length > 13) {
      this.searchForm.controls['Cuit'].setErrors({ 'incorrect': true });
    }
  }

  onSave() {
    let saveAsistencias: SaveEmpleadoAsistencia[] = [];
    this.asistenciasMarcadas.forEach((a: EmpleadoAsistencia) => {
      var nuevaAsistencia = new SaveEmpleadoAsistencia(a.Id, a.FechaAsistencia, a.Asistencia, a.EmpleadoId, a.ComunidadId, a.GremioId, a.HorasAsistencia, a.HorasJornada, a.Observacion, a.MotivoInasistenciaId ?? null);
      saveAsistencias.push(nuevaAsistencia);
    });

    this.isSaving = true;
    this.empleadoService.saveAsistencias(saveAsistencias).subscribe((result) => {
      this.isSaving = false;
      if (result.Success) {
        this.sharedFunctions.showMessage("Las asistencias se guardaron correctamente", "Completado");
        return true;
      }
      else {
        this.sharedFunctions.showMessage(result.Message ?? "Ocurrio un error al guardar las asistencias", "Error");
      }
    },
    (err: HttpErrorResponse) => {
      this.isSaving = false;
      this.sharedFunctions.handleError(err);
    });
  }

  setQueryParams() {
    if (this.query == null)
      this.query = new Query();

    var index = this.query.params.findIndex(obj => obj.key === "ComunidadId");
    if (index >= 0)
      this.query.params[index].value = this.asistenciaForm.value.Comunidad?.Id;
    else
      this.query.addParams("ComunidadId", this.asistenciaForm.value.Comunidad?.Id);

    index = this.query.params.findIndex(obj => obj.key === "FechaDesde");
    if (index >= 0) {
      this.query.params[index].value = this.datePipe.transform(this.asistenciaForm.value.FechaDesde, "yyyy-MM-dd");
    }
    else
      this.query.addParams("FechaDesde", this.datePipe.transform(this.asistenciaForm.value.FechaDesde, "yyyy-MM-dd"));

    index = this.query.params.findIndex(obj => obj.key === "FechaHasta");
    if (index >= 0)
      this.query.params[index].value = this.datePipe.transform(this.asistenciaForm.value.FechaHasta, "yyyy-MM-dd");
    else
      this.query.addParams("FechaHasta", this.datePipe.transform(this.asistenciaForm.value.Fechahasta, "yyyy-MM-dd"));

    index = this.query.params.findIndex(obj => obj.key === "VerSoloActivos");
    if (index >= 0)
      this.query.params[index].value = this.verSoloActivos.toString();
    else
      this.query.addParams("VerSoloActivos", this.verSoloActivos.toString());

    index = this.query.params.findIndex(obj => obj.key === "VerSubContratistas");
    if (index >= 0)
      this.query.params[index].value = null;
    else
      this.query.addParams("VerSubContratistas", null);

    index = this.query.params.findIndex(obj => obj.key === "GremioId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.GremioId;
    else
      this.query.addParams("GremioId", this.searchForm.value.GremioId);

    index = this.query.params.findIndex(obj => obj.key === "SubContratistaId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.SubContratista?.Id;
    else
      this.query.addParams("SubContratistaId", this.searchForm.value.SubContratista?.Id);

    index = this.query.params.findIndex(obj => obj.key === "EmpleadoNombre");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.EmpleadoNombre;
    else
      this.query.addParams("EmpleadoNombre", this.searchForm.value.EmpleadoNombre);

    index = this.query.params.findIndex(obj => obj.key === "EmpleadoApellido");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.EmpleadoApellido;
    else
      this.query.addParams("EmpleadoApellido", this.searchForm.value.EmpleadoApellido);

    index = this.query.params.findIndex(obj => obj.key === "Cuit");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Cuit;
    else
      this.query.addParams("Cuit", this.searchForm.value.Cuit);
  }

  toggleActive(event: MatCheckboxChange) {
    this.verSoloActivos = event.checked;
  }

  buildForm() {
    this.desdeDate.setDate((new Date()).getDate() - 10);
    this.hastaDate.setDate((new Date()).getDate() + 4);

    this.asistenciaForm = this.formBuilder.group({
      'FechaDesde': [this.desdeDate, [Validators.required]],
      'FechaHasta': [this.hastaDate, [Validators.required]],
      'Comunidad': [null, [Validators.required]]
    });

    this.searchForm = this.formBuilder.group({
      'EmpleadoNombre': [null],
      'EmpleadoApellido': [null],
      'Cuit': [null],
      'GremioId': [null],
      'SubContratista': [null]
    });

    this.asistenciaForm.valueChanges.subscribe(() => {
      if (this.asistenciaForm.value?.Comunidad?.Id > 0 && this.asistenciaForm.valid) {
        this.isFormValid = true;
      } else {
        this.isFormValid = false;
      }
    })
  }

  clearDate(formFieldName: string) {
    if (formFieldName != null && formFieldName.length > 0) {
      if (this.asistenciaForm.get(formFieldName) != null && this.asistenciaForm.get(formFieldName)?.value)
        this.asistenciaForm.get(formFieldName)?.setValue(null);
    }
  }

  getTipoAsistencia() {
    this.empleadoService.getTipoAsistencia().subscribe((result) => {
      this.tipoAsistenciaList = result.Result;
    })
  }

  getGremios() {
    var r = new SearchGremioRequest(null, null, null, null, null, null, null);
    this.isGremiosSearching = true;

    this.gremioService.search(r).subscribe(data => {
      this.isGremiosSearching = false;
      this.gremioList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isGremiosSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

  selectEmpleado(isSelected, empleados) {
    let listaEmpleadosSelect = empleados;
    this.selectedEmpleados = listaEmpleadosSelect.filter(f => f.isSelected);
  }

  editFechas(item: any) {
    if (!item || item.EmpleadoId == null || item.EmpleadoId <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
      return false;
    }

    const dialogRef = this.dialog.open(DialogModificarFechaComponent, {
      data: new DialogModificarFechaRequest(0, item.EmpleadoId, this.asistenciaForm.value.Comunidad.Id)
    });
  }

  toolbarClick(): void {
    this.grid.excelExport();
  }

  onSelectedExport() {
    var search = new SearchEmpleadoAsistenciaExport([]);
    search.EmpleadosId = this.selectedEmpleados.map(i => i.EmpleadoId);

    this.isExporting = true;

    this.empleadoService.exportAsistenciasSelected(search).subscribe((data: Blob) => {
      this.isExporting = false;

      const file = new Blob([data], { type: 'text/csv' });
      var fileUrl = URL.createObjectURL(file);

      var anchor = document.createElement("a");
      anchor.download = "Empleados_" + this.datePipe.transform(new Date(), "dd-MM-yyyy") + this.sharedFunctions.getFileExtension(ExportMediaTypeConstants.Csv);
      anchor.href = fileUrl;
      anchor.click();
    },
      (err: HttpErrorResponse) => {
        this.isExporting = false;
        return this.sharedFunctions.handleError(err);
      })
  }

  onExport() {
    if (this.selectedEmpleados?.length > 0) {
      this.onSelectedExport();
    }
    else {
      var search = new SearchEmpleadoRequestDto(null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, this.verSoloActivos);
      search = Object.assign(search, this.searchForm.value);

      this.isExporting = true;
      this.empleadoService.exportSearch(search).subscribe((data: Blob) => {
        this.isExporting = false;
        var fileUrl = URL.createObjectURL(data);

        var anchor = document.createElement("a");
        anchor.download = "Asistencia_" + this.datePipe.transform(new Date(), "dd-MM-yyyy") + this.sharedFunctions.getFileExtension(ExportMediaTypeConstants.Csv);
        anchor.href = fileUrl;
        anchor.click();
      },
        (err: HttpErrorResponse) => {
          this.isExporting = false;
          return this.sharedFunctions.handleError(err);
        })
    }
  }

  DELAY = 200;
  clicks = 0;
  timer: ReturnType<typeof setTimeout>;

  clickHandler(tipoAsis, empleado, dia, meses){
    this.clicks++;

    setTimeout(() => {
      if(this.clicks === 1) {
        this.timer = setTimeout(() => {
          this.comprobarAsist(tipoAsis, empleado, dia, meses, null);
          this.clicks = 0;
        }, this.DELAY);
      }
      else {
        clearTimeout(this.timer);
        this.clicks = 0;
        this.getMotivoInasistencia(tipoAsis, empleado, dia, meses);
      }
    }, 50);
  }

  displayFn(empleado: EmpleadoDto): string {
    return empleado && empleado?.Nombre || empleado?.Apellido ? (empleado.Apellido + ", " + empleado.Nombre).toUpperCase() + " - " + empleado.Cuit : '';
  }

  displayComunidad(comunidad: Comunidad): string {
    var displayWith = this.sharedFunctions.formatComunidadName(comunidad);
    return displayWith;
  }

  getTotalHoras(empleado: any, tipoAsis){
    if(!empleado)
      return false;

    var totalHoras = this.asistenciaList.filter(x => x.EmpleadoId == empleado.EmpleadoId && x.Asistencia == tipoAsis.Id).map(x => x.HorasAsistencia);
    return totalHoras.reduce((prev, curr) => prev + curr, 0);
  }

  // MOTIVO INASISTENCIA

  getMotivoInasistencia(tipoAsistenciaId?, empleado?, dias?, meses?, esDia?) {
    const mes = this.getMes(meses);

    let fechaSeleccionada = dias + "/" + mes + "/" + meses.Anio;
    let fechaAsistencia = meses.Anio + "-" + mes + "-" + dias + "T00:00:00";
    let obraSeleccionada = this.asistenciaForm.get("Comunidad")?.value?.Nombre;

    const dialogRef = this.dialog.open(DialogMotivoInasistenciaComponent, {
      data: new DialogMotivoInasistenciaRequest(empleado?.EmpleadoId ?? 0, tipoAsistenciaId, fechaSeleccionada, fechaAsistencia, obraSeleccionada, esDia, this.asistenciaList),
      autoFocus: false,
    });

    dialogRef.afterClosed().subscribe((dialogRes: DialogMotivoInasistenciaResponse) => {
      if(!dialogRes || !dialogRes.Accepted)
        return;
      this.guardarMotivoInasistencia(dialogRes)
    })
  }

  guardarMotivoInasistencia(dialogRes: DialogMotivoInasistenciaResponse) {
    this.comprobarAsist(dialogRes.TipoAsistencia, null, null, null, dialogRes);
  }
}
